import React from 'react';
export const NoteContext=React.createContext(
{
notes:[] ,
total:0,
getNotes:function(){},
addSingleNote:function(note){
    console.log('Note Adding');
    return note;
}
});

export default NoteContext;